import { useSelector } from 'react-redux'
import * as sessionSelector from 'selectors/session'

import ComcastCopyrightRenderer from './ComcastCopyrightRenderer'

const ComcastCopyright = ({ className }) => {
  const mainPartner = useSelector(sessionSelector.mainPartner)
  return (
    <ComcastCopyrightRenderer
      className={className}
      icon={mainPartner?.systemBrandingIcon}
      text={mainPartner?.systemBrandingCopyrightText}
    />
  )
}

export default ComcastCopyright
